<div class="flex flex-row">
  <app-tag-atom
    *ngFor="let tag of tags"
    [text]="tag.text"
    [url]="tag.url"
    class="mr-1"
  ></app-tag-atom>
</div>
